import React from 'react';
import { Link } from 'react-router-dom';

import ImageCarousel from '../components/ImageCarousel';
import TestimonialSection from '../components/TestimonialSection';
import ScrollReveal from '../components/ScrollReveal';
//import TeacherProgramSection from '../components/TeacherProgramSection.js';

import iF_badge from '../assets/images/iF_social_impact_badge.png';
import iF_awardImage from '../assets/home_images/iF_AwardImage.jpg';
import CommunityService from '../assets/home_images/CommunityService.jpg';
import Impact from '../assets/home_images/WealthyCatsImpact.jpg';

import iF_logo from '../assets/home_images/iF_logo.png';
import BOT_logo from '../assets/home_images/Bank_of_Thailand_logo.png';
import BIZNews_logo from '../assets/home_images/BangkokBizNews_logo.jpg';

import WealthyCatsBook from '../assets/home_images/WealthyCatsBook.png';
import WealthyCatsBoardGame from '../assets/home_images/WealthyCats.jpg';
import WealthyOwlBoardGame from '../assets/home_images/WealthyOwl.jpg';

import Kids from '../assets/home_images/Kids.jpg';
import Adults from '../assets/home_images/Adults.jpg';
import Corporate from '../assets/home_images/Corporate.jpg';
import PrivateGroup from '../assets/home_images/PrivateGroup.jpg';

import reddot1 from '../assets/home_images/reddot1.jpg';
import reddot2 from '../assets/home_images/reddot2.jpg';
import reddot3 from '../assets/home_images/reddot3.jpg';
import reddot4 from '../assets/home_images/reddot4.jpg';
import reddot_logo from '../assets/home_images/reddot_logo.jpg';

import CatMascot from '../assets/home_images/cat.png';
import OwlMascot from '../assets/home_images/owl.png';


const reddotGallery = [
  { src: reddot1, caption: 'Exhibition entrance — Constellation Resonance, Chengdu' },
  { src: reddot2, caption: 'The WealthyCats panel: Play to Build Financial Resilience' },
  { src: reddot3, caption: 'WealthyCats board game on display' },
  { src: reddot4, caption: 'Social design projects from across Asia' },
];

function Home() {
  const [zoomImage, setZoomImage] = React.useState(null);
  const [reddotActive, setReddotActive] = React.useState(0);
  return (
    <div className="min-h-screen">
      {/* Hero Section — Playful Brand Stage */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#FED700] via-[#FDC70C] to-[#F4900C] pt-28 sm:pt-32 md:pt-36 pb-14 md:pb-20">
        {/* Floating decorations */}
        <div className="absolute top-24 left-[6%] w-12 h-12 md:w-16 md:h-16 rounded-full bg-white/20 animate-floaty"></div>
        <div className="absolute top-[35%] right-[6%] w-16 h-16 md:w-24 md:h-24 rounded-full bg-white/15 animate-floaty" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-28 left-[10%] w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/25 animate-floaty" style={{ animationDelay: '2s' }}></div>
        {/* Floating coins */}
        <div className="absolute top-24 right-[10%] md:right-[22%] w-9 h-9 md:w-12 md:h-12 rounded-full bg-white/90 border-4 border-[#F4900C]/40 shadow-lg flex items-center justify-center font-extrabold text-[#F4900C] text-sm md:text-xl animate-floaty" style={{ '--r': '12deg', animationDelay: '0.5s' }}>฿</div>
        <div className="absolute bottom-[30%] left-[4%] md:left-auto md:right-[6%] md:bottom-40 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/90 border-4 border-[#F4900C]/40 shadow-lg flex items-center justify-center font-extrabold text-[#F4900C] text-xs md:text-base animate-floaty" style={{ '--r': '-8deg', animationDelay: '1.5s' }}>$</div>
        {/* Floating game cards (large screens only) */}
        <div className="absolute top-1/3 left-[3%] w-16 h-24 rounded-xl bg-white/80 shadow-xl animate-floaty hidden lg:block" style={{ '--r': '-10deg', animationDelay: '0.8s' }}>
          <div className="m-2 h-10 rounded-lg bg-gradient-to-br from-[#FED700] to-[#F4900C]"></div>
          <div className="mx-2 h-2 rounded bg-gray-200"></div>
          <div className="mx-2 mt-1 h-2 w-8 rounded bg-gray-200"></div>
        </div>
        <div className="absolute bottom-1/4 right-[2%] w-16 h-24 rounded-xl bg-white/80 shadow-xl animate-floaty hidden lg:block" style={{ '--r': '8deg', animationDelay: '2.2s' }}>
          <div className="m-2 h-10 rounded-lg bg-gray-900"></div>
          <div className="mx-2 h-2 rounded bg-gray-200"></div>
          <div className="mx-2 mt-1 h-2 w-8 rounded bg-gray-200"></div>
        </div>

        <div className="container-custom relative z-10">
          {/* Headline flanked by mascots (mascots shown md+) */}
          <div className="flex items-center justify-center gap-4 md:gap-10 mb-4 sm:mb-6 animate-hero-up" style={{ animationDelay: '0.1s' }}>
            <img
              src={CatMascot}
              alt="WealthyCats mascot"
              className="hidden md:block h-28 lg:h-36 w-auto animate-floaty drop-shadow-xl"
              style={{ '--r': '-6deg' }}
            />
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold text-gray-900 leading-none tracking-tight text-center">
              WealthyCats
            </h1>
            <img
              src={OwlMascot}
              alt="Wealthy Owl mascot"
              className="hidden md:block h-24 lg:h-32 w-auto animate-floaty drop-shadow-xl"
              style={{ '--r': '6deg', animationDelay: '1.2s' }}
            />
          </div>

          {/* Tagline */}
          <p className="text-center text-lg sm:text-xl md:text-2xl text-gray-800 font-medium max-w-2xl mx-auto mb-8 px-2 animate-hero-up" style={{ animationDelay: '0.25s' }}>
            Financial education that feels like playtime — for families, schools, and communities.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-10 md:mb-14 animate-hero-up" style={{ animationDelay: '0.4s' }}>
            <Link
              to="/products"
              className="w-full sm:w-auto text-center bg-gray-900 text-white font-bold py-3 sm:py-4 px-8 rounded-lg shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all duration-300 text-base sm:text-lg"
            >
              Explore Our Products
            </Link>
            <Link
              to="/academy"
              className="w-full sm:w-auto text-center bg-white text-gray-900 font-semibold py-3 sm:py-4 px-8 rounded-lg shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 text-base sm:text-lg"
            >
              View Workshop Programs
            </Link>
            <Link
              to="/organization/about"
              className="text-gray-900 hover:text-white font-semibold text-base sm:text-lg transition-colors flex items-center gap-2"
            >
              Learn Our Story <span>→</span>
            </Link>
          </div>

          {/* Framed photo carousel */}
          <div className="animate-hero-up" style={{ animationDelay: '0.55s' }}>
            <div className="max-w-4xl mx-auto -rotate-1 hover:rotate-0 transition-transform duration-500 relative">
              {/* Award sticker on the frame (md+) */}
              <div className="hidden md:inline-flex absolute -top-5 right-8 z-30 items-center gap-2 bg-white/95 px-4 py-2 rounded-full shadow-xl border-2 border-[#F4900C]/20">
                <img
                  src={iF_badge}
                  alt="iF Social Impact Award"
                  className="h-5 w-auto object-contain"
                />
                <span className="font-semibold text-gray-900 text-xs">
                  iF Social Impact Prize 2025 Winner
                </span>
              </div>

              {/* Mobile mascots at the bottom corners of the frame */}
              <img
                src={CatMascot}
                alt="WealthyCats mascot"
                className="md:hidden absolute -bottom-3 -left-2 h-20 w-auto z-30 animate-floaty drop-shadow-xl"
                style={{ '--r': '-5deg' }}
              />
              <img
                src={OwlMascot}
                alt="Wealthy Owl mascot"
                className="md:hidden absolute -bottom-3 -right-2 h-16 w-auto z-30 animate-floaty drop-shadow-xl"
                style={{ '--r': '5deg', animationDelay: '1.2s' }}
              />

              <div className="rounded-2xl sm:rounded-3xl border-4 sm:border-8 border-white shadow-2xl overflow-hidden h-[240px] sm:h-[340px] md:h-[440px] relative">
                <ImageCarousel />
              </div>
            </div>

            {/* Award pill under the carousel (mobile) */}
            <div className="md:hidden flex justify-center mt-5">
              <div className="inline-flex items-center gap-2 bg-white/95 px-4 py-2 rounded-full shadow-lg">
                <img
                  src={iF_badge}
                  alt="iF Social Impact Award"
                  className="h-5 w-auto object-contain"
                />
                <span className="font-semibold text-gray-900 text-xs">
                  iF Social Impact Prize 2025 Winner
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Featured Exhibition: Red Dot — 2026 Asia Social Design Exhibition */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-orange-50/40 via-white to-yellow-50/40">
        <div className="container-custom">
          {/* "Now On Exhibition" eyebrow */}
          <ScrollReveal>
          <div className="flex justify-center mb-6">
            <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#F4900C]">
              <span className="h-px w-8 bg-[#F4900C]/40"></span>
              Now On Exhibition
              <span className="h-px w-8 bg-[#F4900C]/40"></span>
            </span>
          </div>
          </ScrollReveal>

          <ScrollReveal delay={150}>
          <div className="max-w-6xl mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden border border-orange-100">
            <div className="grid md:grid-cols-[3fr_2fr] gap-0">
              {/* Left: Exhibition photo gallery */}
              <div className="bg-gray-900 p-3 sm:p-4 flex flex-col gap-3">
                <button
                  type="button"
                  onClick={() => setZoomImage(reddotGallery[reddotActive].src)}
                  className="group relative block w-full flex-1 min-h-[220px] sm:min-h-[300px] overflow-hidden rounded-xl cursor-zoom-in"
                >
                  <img
                    src={reddotGallery[reddotActive].src}
                    alt={reddotGallery[reddotActive].caption}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 sm:p-4">
                    <p className="text-white text-xs sm:text-sm font-medium text-left">
                      {reddotGallery[reddotActive].caption}
                    </p>
                  </div>
                </button>

                {/* Thumbnails */}
                <div className="grid grid-cols-4 gap-2 sm:gap-3">
                  {reddotGallery.map((photo, index) => (
                    <button
                      key={photo.src}
                      type="button"
                      onClick={() => setReddotActive(index)}
                      aria-label={photo.caption}
                      aria-current={index === reddotActive}
                      className={`relative overflow-hidden rounded-lg border-2 transition-all duration-300 ${
                        index === reddotActive
                          ? 'border-[#FED700] opacity-100'
                          : 'border-transparent opacity-60 hover:opacity-100'
                      }`}
                    >
                      <img
                        src={photo.src}
                        alt={photo.caption}
                        className="w-full h-14 sm:h-20 object-cover"
                      />
                    </button>
                  ))}
                </div>
              </div>

              {/* Right: Exhibition branding + info */}
              <div className="p-6 sm:p-7 md:p-8 lg:p-10 flex flex-col justify-center border-t md:border-t-0 md:border-l border-gray-100">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-white rounded-xl shadow-md flex items-center justify-center flex-shrink-0 border border-gray-100">
                    <img
                      src={reddot_logo}
                      alt="Red Dot"
                      className="w-12 h-12 sm:w-14 sm:h-14 object-contain"
                    />
                  </div>
                  <div>
                    <p className="text-lg sm:text-xl font-bold text-gray-900">Reddot Design Museum</p>

                  </div>
                </div>

                <h3 className="text-xl sm:text-2xl md:text-2xl font-bold text-gray-900 leading-snug mb-3">
                  WealthyCats joins <span className="text-[#F4900C]">Constellation Resonance</span> — the 2026 Asia Social Design Exhibition
                </h3>

                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                    Chengdu, China
                  </span>
                  <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                    30 Jul – 8 Oct 2026
                  </span>
                </div>

                <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-5">
                  <span className="font-semibold text-gray-800">WealthyCats</span> is
                  on show at Constellation Resonance, an exhibition gathering social design projects from 10 Asian
                  countries and regions. Our board games, cards and community workshops are presented as an example of
                  how play-based learning turns financial literacy into something joyful, culturally grounded, and
                  driven by the community itself.
                </p>

                <a
                  href="https://en.red-dot.cn/index.php?a=show&m=Article&id=80"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 self-start bg-gradient-to-r from-[#FED700] to-[#F4900C] hover:from-[#FED700]/90 hover:to-[#F4900C]/90 text-gray-900 font-bold py-3 px-6 text-sm sm:text-base rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5"
                >
                  Visit the Exhibition Page
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Products Section */}
    <section className="py-20 bg-white">
    <div className="container-custom">
        {/* Section Header */}
        <ScrollReveal>
        <div className="text-center mb-16">

        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Financial Literacy Made <span className="text-[#F4900C]">Fun</span>
        </h2>
        {/* text */}
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Learn money management and investing through games and stories designed for families and young learners.
        </p>
        </div>
        </ScrollReveal>

        {/* Products Grid */}
        <ScrollReveal delay={150}>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {/* Product Card 1 */}
        {/* WealthyCats Board Game Card */}
        <Link 
          to="/products/wealthycats-board-game"
          className="group bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-transparent hover:border-[#F4900C] transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
        >
          <div className="relative bg-gradient-to-br from-yellow-50 to-orange-50 overflow-hidden">
            <img 
              src={WealthyCatsBoardGame}
              alt="WealthyCats Board Game"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute top-4 right-4 bg-gradient-to-r from-[#FED700] to-[#F4900C] text-gray-900 font-bold px-4 py-1 rounded-full text-sm shadow-lg">
              iF Award
            </div>
          </div>

          <div className="p-6">
            <div className="flex justify-between items-start mb-3">
              <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#F4900C] transition-colors">
                WealthyCats Board Game
              </h3>
              {/* <span className="text-2xl font-bold text-[#F4900C]">
                ฿2,340
              </span> */}
            </div>
            
            <p className="text-gray-600 mb-4">
              Transform financial concepts into fun family gameplay. Learn earning, saving, investing through real-life scenarios.
            </p>

            <div className="flex flex-wrap gap-2">
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Ages 9+
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                2-4 Players
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                30-45 min
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Family Learning
              </span>
            </div>
          </div>
        </Link>

        {/* WealthyOwl Board Game Card */}
        <Link 
          to="/products/wealthyowl-board-game"
          className="group bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-transparent hover:border-[#F4900C] transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
        >
          <div className="relative bg-gradient-to-br from-yellow-50 to-orange-50 overflow-hidden">
            <img 
              src={WealthyOwlBoardGame}
              alt="WealthyOwl Board Game"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute top-4 right-4 bg-gradient-to-r from-[#FED700] to-[#F4900C] text-gray-900 font-bold px-4 py-1 rounded-full text-sm shadow-lg">
              New Release
            </div>
          </div>

          <div className="p-6">
            <div className="flex justify-between items-start mb-3">
              <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#F4900C] transition-colors">
                WealthyOwl Board Game
              </h3>
              {/* <span className="text-2xl font-bold text-[#F4900C]">
                ฿2,340
              </span> */}
            </div>
            
            <p className="text-gray-600 mb-4">
              Master long-term investing with 6 asset types. Build portfolios, manage risks, and grow wealth through strategic play.
            </p>

            <div className="flex flex-wrap gap-2">
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Ages 12+
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                1-3 Players
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                30-45 min
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Investing Focus
              </span>
            </div>
          </div>
        </Link>

        {/* The Inner Wealth Playbook Card */}
        <Link 
          to="/products/the-inner-wealth-playbook-english-version"
          className="group bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-transparent hover:border-[#F4900C] transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
        >
          <div className="relative bg-gradient-to-br from-yellow-50 to-orange-50 overflow-hidden">
            <img 
              src={WealthyCatsBook}
              alt="The Inner Wealth Playbook"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute top-4 right-4 bg-gradient-to-r from-[#FED700] to-[#F4900C] text-gray-900 font-bold px-4 py-1 rounded-full text-sm shadow-lg">
              2,000+ Sold
            </div>
          </div>

          <div className="p-6">
            <div className="flex justify-between items-start mb-3">
              <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#F4900C] transition-colors">
                The Inner Wealth Playbook
              </h3>
              {/* <span className="text-2xl font-bold text-[#F4900C]">
                ฿375
              </span> */}
            </div>
            
            <p className="text-gray-600 mb-4">
              Financial literacy companion book with 7 essential money lessons. Learn through storytelling and practical exercises.
            </p>

            <div className="flex flex-wrap gap-2">
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Ages 9+
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Thai & English
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Used by BOT
              </span>
              <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                Game Companion
              </span>
            </div>
          </div>
        </Link>
        </div>
        </ScrollReveal>

        {/* CTA button */}
        <ScrollReveal delay={250}>
        <div className="text-center">
        <Link
            to="/products"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FED700] to-[#F4900C] hover:from-[#FED700]/90 hover:to-[#F4900C]/90 text-gray-900 font-bold py-4 px-8 rounded-lg hover:shadow-lg transition-all duration-300 text-lg"
        >
            View All Products
            <span>→</span>
        </Link>
        </div>
        </ScrollReveal>
    </div>
    </section>

    {/* Workshops Section */}
    <section className="py-20 bg-gradient-to-br from-orange-50 via-yellow-50 to-white">
      <div className="container-custom">
        {/* Section Header */}
        <ScrollReveal>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <span className="text-[#F4900C]">Workshops</span> & Programs
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Interactive learning experiences for kids, teens, adults, and organizations.
            Build financial confidence through hands-on activities.
          </p>
        </div>
        </ScrollReveal>

        {/* Workshop Images Grid*/}
        <ScrollReveal delay={150}>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {/* Workshop 1: Kids Financial Literacy */}
          <Link 
            to="/academy/kids"
            className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer block"
          >
            <img 
              src={Kids}
              alt="Kids Financial Literacy Workshop"
              className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-end p-6">
              <div className="text-white transform group-hover:translate-y-[-5px] transition-transform duration-300">
                <h3 className="font-bold text-lg mb-1">Kids</h3>
                <p className="text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Ages 5-12 • Interactive games
                </p>
              </div>
            </div>
            {/* Hover overlay with arrow */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <span className="text-white font-bold text-lg flex items-center gap-2">
                Learn More <span className="text-[#FED700]">→</span>
              </span>
            </div>
          </Link>

          {/* Workshop 2: Teens & Adults */}
          <Link 
            to="/academy/teens-adults"
            className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer block"
          >
            <img 
              src={Adults}
              alt="Teens & Adults Financial Workshop"
              className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-end p-6">
              <div className="text-white transform group-hover:translate-y-[-5px] transition-transform duration-300">
                <h3 className="font-bold text-lg mb-1">Teens & Adults</h3>
                <p className="text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Ages 13+ • Real-world scenarios
                </p>
              </div>
            </div>
            {/* Hover overlay with arrow */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <span className="text-white font-bold text-lg flex items-center gap-2">
                Learn More <span className="text-[#FED700]">→</span>
              </span>
            </div>
          </Link>

          {/* Workshop 3: Private Group */}
          <Link 
            to="/academy/private-group"
            className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer block"
          >
            <img 
              src={PrivateGroup}
              alt="Corporate Financial Training"
              className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-end p-6">
              <div className="text-white transform group-hover:translate-y-[-5px] transition-transform duration-300">
                <h3 className="font-bold text-lg mb-1">Private Group</h3>
                <p className="text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Customized financial programs
                </p>
              </div>
            </div>
            {/* Hover overlay with arrow */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <span className="text-white font-bold text-lg flex items-center gap-2">
                Learn More <span className="text-[#FED700]">→</span>
              </span>
            </div>
          </Link>

          {/* Workshop 4: Corporate Training */}
          <Link 
            to="/academy/corporate"
            className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer block"
          >
            <img 
              src={Corporate}
              alt="Corporate Financial Training"
              className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-end p-6">
              <div className="text-white transform group-hover:translate-y-[-5px] transition-transform duration-300">
                <h3 className="font-bold text-lg mb-1">Corporate</h3>
                <p className="text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Team building • Financial wellness
                </p>
              </div>
            </div>
            {/* Hover overlay with arrow */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <span className="text-white font-bold text-lg flex items-center gap-2">
                Learn More <span className="text-[#FED700]">→</span>
              </span>
            </div>
          </Link>
        </div>
        </ScrollReveal>

        {/* Main CTA Button */}
        <ScrollReveal delay={250}>
        <div className="text-center">
          <Link
            to="/academy"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FED700] to-[#F4900C] hover:from-[#FED700]/90 hover:to-[#F4900C]/90 text-gray-900 font-bold py-4 px-8 rounded-lg hover:shadow-lg transition-all duration-300 text-lg transform hover:-translate-y-0.5"
          >
            Explore All Academy Programs
            <span>→</span>
          </Link>
        </div>
        </ScrollReveal>
      </div>
    </section>



      {/* iF Impact Prize 2025 news Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="container-custom">
          {/* Section Header */}
          <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              iF Social Impact Prize 2025 Winner
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                WealthyCats is a winner of the iF Social Impact Prize 2025
                in the Quality Education category, recognized for empowering youth and communities in support of
                the UN Sustainable Development Goal 4.
            </p>


          </div>
          </ScrollReveal>

          {/* Content Grid */}
          <ScrollReveal delay={150}>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left - Images */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src={iF_awardImage} 
                  alt="iF Social Impact Prize 2025" 
                  className="w-full h-auto object-cover"
                />
              </div>
              
              {/* Secondary image */}
              <div className="mt-6 grid grid-cols-2 gap-4">

                <div className="relative rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src={Impact}
                    alt="WealthyCats Impact" 
                    onClick={() => setZoomImage(Impact)}
                    className="w-full h-40 object-cover cursor-zoom-in hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute bottom-0 left-0 right-0 p-3 text-white bg-black/20">
                    <p className="font-semibold text-sm">Community Workshop</p>
                  </div>
                </div>

                <div className="relative rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src={CommunityService} 
                    alt="Community Workshop"
                    onClick={() => setZoomImage(CommunityService)} 
                    className="w-full h-40 object-cover cursor-zoom-in hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute bottom-0 left-0 right-0 p-3 text-white bg-black/20">
                    <p className="font-semibold text-sm">โครงการ "สอนหนูรู้เรื่องเงิน" at Bank of Thailand</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right - Content & Links */}
            <div>
              <div className="prose prose-lg max-w-none">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Recognition for Social Impact
                </h3>
                <p className="text-gray-700 mb-6">
                  The iF Impact Prize celebrates design projects that address urgent social challenges. 
                  WealthyCats was selected from thousands of global entries for our innovative approach 
                  to financial literacy education for underserved children.
                </p>
                
                <div className="bg-gradient-to-r from-[#FED700]/10 to-[#F4900C]/10 border-l-4 border-[#F4900C] p-6 rounded-lg mb-6">
                  <h4 className="font-bold text-gray-900 mb-2">Our Impact</h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-[#F4900C] mr-2">✓</span>
                      <span>Reached 1,000+ children in underserved communities</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#F4900C] mr-2">✓</span>
                      <span>Partnered with 20+ schools and community centers</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#F4900C] mr-2">✓</span>
                      <span>Created sustainable financial education model</span>
                    </li>
                  </ul>
                </div>

                {/* News Links 1*/}
                <div className="space-y-3 mb-6">
                  <h4 className="font-bold text-gray-900 mb-3">Media Coverage</h4>
                  
                  <a 
                    href="https://ifdesign.com/en/winner-ranking/project/wealthycats-play-to-build-financial-resilience/737597" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-4 bg-white border border-gray-200 rounded-lg hover:border-[#F4900C] hover:shadow-md transition-all duration-300 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#FED700] to-[#F4900C] rounded-lg flex items-center justify-center">
                      <img 
                        src={iF_logo} 
                        alt="iF logo" 
                        className="w-full h-auto object-cover"
                     />
                    </div>

                    <div className="flex-grow">
                      <p className="font-semibold text-gray-900 group-hover:text-[#F4900C]">
                        iF Design Official Announcement
                      </p>
                      <p className="text-sm text-gray-600">View our project on iF World Design web page </p>
                    </div>
                    <span className="text-[#F4900C] group-hover:translate-x-1 transition-transform">→</span>
                  </a>

                  {/* News Links 2*/}
                  <a 
                    href="https://www.bot.or.th/th/research-and-publications/articles-and-publications/bot-magazine/phrasiam-68-3/FinWis-FinLitClass.html" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-4 bg-white border border-gray-200 rounded-lg hover:border-[#F4900C] hover:shadow-md transition-all duration-300 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br [#FFFFFF] rounded-lg flex items-center justify-center">
                      <img 
                        src={BOT_logo} 
                        alt="BOT logo" 
                        className="w-full h-auto object-cover"
                     />
                    </div>
                    <div className="flex-grow">
                      <p className="font-semibold text-gray-900 group-hover:text-[#F4900C]">
                        BOT magazine (Bank of Thailand)
                      </p>
                      <p className="text-sm text-gray-600">Read the full article</p>
                    </div>
                    <span className="text-[#F4900C] group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                  
                  {/* News Links 2*/}
                  <a 
                    href="https://www.bangkokbiznews.com/health/education/1193400" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-4 bg-white border border-gray-200 rounded-lg hover:border-[#F4900C] hover:shadow-md transition-all duration-300 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br [#FFFFFF] rounded-lg flex items-center justify-center">
                      <img 
                        src={BIZNews_logo} 
                        alt="BIZNews logo" 
                        className="w-full h-auto object-cover"
                     />
                    </div>
                    <div className="flex-grow">
                      <p className="font-semibold text-gray-900 group-hover:text-[#F4900C]">
                        กรุงเทพธุรกิจ
                      </p>
                      <p className="text-sm text-gray-600">Read the full article</p>
                    </div>
                    <span className="text-[#F4900C] group-hover:translate-x-1 transition-transform">→</span>
                  </a>

                </div>

              </div>
            </div>
          </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Teacher program section */}
      {/*<TeacherProgramSection/>*/}

      {/* Testimonial section */}
      <ScrollReveal>
        <TestimonialSection/>
      </ScrollReveal>

      {zoomImage && (
      <div
        className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-zoom-out"
        onClick={() => setZoomImage(null)}
      >
        <div className="relative max-w-6xl max-h-full">
          {/* Close button */}
          <button
            onClick={() => setZoomImage(null)}
            className="absolute -top-12 right-0 text-white text-4xl hover:text-gray-300"
          >
            ×
          </button>

          <img
            src={zoomImage}
            alt="Zoomed"
            className="max-w-full max-h-[90vh] object-contain rounded-xl shadow-2xl"
          />
        </div>
      </div>
    )}

    </div>
  );
}

export default Home;